module.exports = __webpack_public_path__ + "static/img/mb-04.69f5b06.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/x3/mb-04.jpg
// module id = dMiP
// module chunks = 1